import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';
import { getFirstImage } from 'lib/assets/assets_helpers';
import noimg from 'assets/img/noimg.gif';

class AssetDetailGeneral extends Component {
  state = { isModalOpen: false };

  openModal = e => {
    e.preventDefault();
    const { asset } = this.props;
    const file = getFirstImage(asset._files) || noimg;
    const fullSrc = file.url || file;
    new Image().src = fullSrc;

    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  render() {
    const { asset, t } = this.props;
    const file = getFirstImage(asset._files) || noimg;
    const fullSrc = file.url || file;
    const thumbSrc = file.thumbUrl || fullSrc;

    return (
      <div>
        <Form.Section title={t('assets.section.general')}>
          <div className="row">
            <div className="col-md-4 text-center mb-4 mb-md-0">
              <a href={fullSrc} onClick={this.openModal}>
                <img
                  src={thumbSrc}
                  loading="lazy"
                  alt={asset.name || t('assets.fields.image')}
                  className="img-fluid"
                  style={{
                    maxHeight: 200,
                    borderRadius: 6,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                  }}
                />
              </a>
            </div>

            {/* Datos en tabla */}
            <div className="col-md-8">
              <table className="table table-borderless mb-0">
                <tbody>
                  <tr>
                    <th className="font-weight-normal" style={{ width: '25%' }}>
                      {t('assets.fields.number')}:
                    </th>
                    <td style={{ width: '25%' }}>{asset.number || '-'}</td>
                    <th className="font-weight-normal" style={{ width: '25%' }}>
                      {t('assets.fields.serie')}:
                    </th>
                    <td style={{ width: '25%' }}>{asset.serie || '-'}</td>
                  </tr>
                  <tr>
                    <th className="font-weight-normal">{t('assets.fields.name')}:</th>
                    <td>{asset.name || '-'}</td>
                    <th className="font-weight-normal">{t('assets.fields.model')}:</th>
                    <td>{asset.model || '-'}</td>
                  </tr>
                  <tr>
                    <th className="font-weight-normal">{t('assets.fields.brand')}:</th>
                    <td>{asset.brand || '-'}</td>
                    <th className="font-weight-normal">{t('assets.fields.physicalState')}:</th>
                    <td>
                      {asset._physicalState && asset._physicalState.label
                        ? asset._physicalState.label
                        : '-'}
                    </td>
                  </tr>
                  <tr>
                    <th className="font-weight-normal">{t('assets.fields.buyDate')}:</th>
                    <td>{asset.buyDate || '-'}</td>
                    <th className="font-weight-normal">{t('assets.fields.country')}:</th>
                    <td>
                      {asset._country && asset._country.label
                        ? asset._country.label
                        : '-'}
                    </td>
                  </tr>
                  <tr>
                    <th className="font-weight-normal">{t('assets.fields.description')}:</th>
                    <td colSpan="3">{asset.description || '-'}</td>
                  </tr>
                  <tr>
                    <th className="font-weight-normal">{t('assets.fields.custodyNotes')}:</th>
                    <td colSpan="3" style={{ whiteSpace: 'pre-line' }}>
                      {asset.custodyNotes || '-'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Form.Section>

        {/* Modal lightbox */}
        {this.state.isModalOpen && (
          <div
            onClick={this.closeModal}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0,0,0,0.9)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 9999
            }}
          >
            <button
              onClick={this.closeModal}
              style={{
                position: 'fixed',
                top: 20,
                right: 20,
                background: 'transparent',
                border: 'none',
                fontSize: 32,
                color: '#fff',
                cursor: 'pointer',
                zIndex: 10000
              }}
            >
              &times;
            </button>
            <img
              src={fullSrc}
              alt={asset.name || t('assets.fields.image')}
              style={{
                maxWidth: '100vw',
                maxHeight: '100vh',
                objectFit: 'contain',
                borderRadius: 6
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default translate()(AssetDetailGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailGeneral.js